import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 12,
			r: 11,
			stroke: "#C43A00",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 8V13",
			stroke: "#C43A00",
			strokeWidth: 2,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 12,
			cy: 16,
			r: 1,
			fill: "#C43A00"
		})
	]
});
export default SvgWarning;
